import cssVariables from 'tfs.css-variables'

export default {
  thead: {
    display: 'flex',
    textAlign: 'left',
    fontWeight: 'normal',
    padding: '0 0 0.5rem',
    borderBottom: `1px solid ${cssVariables.colorGrayE}`,
  },
  cel: {
    flexBasis: '10rem',
    alignSelf: 'center',
  },
  celError: {
    padding: '0 0 1rem',
  },
}
